export default __webpack_public_path__ + "static/media/add-image_darkGray2.526f3f70.svg";